module.exports = __webpack_public_path__ + "img/PT980250390.e7dffcd2.png";